module.exports = __webpack_public_path__ + "static/media/cristina.3ccf8db2.jpg";